var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import NextLink from 'next/link';
// Redesign-wide internal link. Wraps next/link (Next 12 legacy behavior: a single <a> child) so
// in-app navigation between redesign pages stays client-side instead of triggering a full document
// reload. Use only for internal app routes. For external URLs, mailto:, and #hash anchors keep a
// plain <a>. For links that live inside a Radix `asChild` slot (Button asChild, TooltipTrigger
// asChild, etc.) wrap that component with `<NextLink ... passHref legacyBehavior>` instead, so the
// slot can forward its ref onto the underlying <a>.
export const RedesignLink = forwardRef((_a, ref) => {
    var { href, children } = _a, rest = __rest(_a, ["href", "children"]);
    return (<NextLink href={href}>
			<a ref={ref} {...rest}>{children}</a>
		</NextLink>);
});
RedesignLink.displayName = 'RedesignLink';
